import { useTranslations } from 'use-intl';

export const isRTL = (lang = null) => {
  if (lang) return lang === 'ar';
  return document.dir === 'rtl';
};

export const useTranslation = () => {
  const t = useTranslations();
  return (key, params = {}) => t(key, params);
};

export const getLangRegionCodeByPathName = (type = '', pathname) => {
  if (pathname){
    const pathnameArr = pathname.split('/');
    if(pathnameArr?.[1]) {
      const segments = pathnameArr?.[1]?.split('-');
      if(type === 'region' && segments?.[0]) return segments[0];
      if(type === 'lang' && segments?.[1]) return segments[1];
    }
  }
  return '';
}
